import React, { createContext, useState, useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [isBeta, setIsBeta] = useState(null); // null = loading, true/false = resolved

  // Check for stored token on component mount — verify it hasn't expired
  useEffect(() => {
    const storedToken = localStorage.getItem('auth_token');
    if (storedToken) {
      try {
        const payload = JSON.parse(atob(storedToken.split('.')[1]));
        if (payload.exp && Date.now() / 1000 > payload.exp) {
          localStorage.removeItem('auth_token');
          setIsBeta(false);
          return;
        }
        setAuthToken(storedToken);
        setIsLoggedIn(true);
      } catch {
        localStorage.removeItem('auth_token');
        setIsBeta(false);
      }
    } else {
      setIsBeta(false);
    }
  }, []);

  // Fetch user profile whenever token changes
  useEffect(() => {
    if (!authToken) return;
    fetch(`${BACKEND_URL}/api/auth/me`, {
      headers: { Authorization: `Bearer ${authToken}` }
    })
      .then(r => r.json())
      .then(data => {
        setUser(data);
        setIsBeta(data.is_beta === true);
      })
      .catch(() => setIsBeta(false));
  }, [authToken]);

  const logout = () => {
    localStorage.removeItem('auth_token');
    setAuthToken(null);
    setIsLoggedIn(false);
    setUser(null);
    setIsBeta(false);
  };

  return (
    <AuthContext.Provider
      value={{
        authToken,
        setAuthToken,
        isLoggedIn,
        setIsLoggedIn,
        user,
        setUser,
        isBeta,
        setIsBeta,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
